export default {
	Slide: 'puzzle',
	Puzzle: 'Puzzle',
	'The puzzle is open!': 'Le puzzle est ouvert !',
	'Congratulations!': 'Félicitations!',
	'You get it': 'Tu a compris',
	'You get the task done': 'Tu as fini la tâche',

	'Show all blocked': 'Afficher tout bloqué',

	Author: 'Auteur',
	'Reset filters': 'Réinitialiser les filtres',

	Blocked: 'Bloqué',
	Unlocked: 'Débloqué',

	Change: 'Changement',
	'The student is blocked': "L'élève est bloqué",
	'The student is blocked with a new price':
		"L'étudiant est bloqué avec un nouveau prix",
	'To unlock this student, go to the "Restore" section':
		'Pour débloquer cet élève, rendez-vous dans la rubrique "Récupération"',

	'Before blocking, you can change the price for the student':
		"Avant de bloquer, vous pouvez modifier le prix pour l'étudiant",

	'Block student': "Bloquer l'élève",

	'First month cost': 'Prix pour 1 mois',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'AVERTISSEMENT!Après  avoir enregistré cette tâche, les étudiants qui l ont déjà fini devront le faire à nouveau.',

	"You cannot do homework in the student's platform":
		'Vous ne pouvez pas faire le devoir dans la plateforme de l étudiant',

	'Restore the student ?': 'Réstorer cet étudiant?',
	'Restore the teacher ?': 'Restaurer le professeur ?',
	'Restore the franchise ?': 'Restaurer la franchise ?',

	'Transition to 50': 'passage à 50',
	'Transition to 100': 'passage à 100',

	fifty: 'passage à 50',
	hundred: 'passage à 100',

	Heroes: 'Héros',
	Clothes: 'Vétéments',
	Backgrounds: 'fond d écran',
	Souvenirs: 'Souvenirs',

	'Coming soon': 'Bientôt disponible',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Waouh! Bravo, tu as achété cet article avec succès.',
	'You can view all your purchases in the "Purchased" section':
		'Tu peux voir tout tes achats dans la section "Achétés"',

	'Your savings': 'Ton épargne',
	'You can spend them on something interesting!':
		'Tu peux les dépenser pour quelque chose  d intéressant!',

	'A student with this email address already exists':
		'Un étudiant avec cette adresse e-mail existe déjà',

	'User with such email already exists':
		'Un utilisateur avec cette adresse e-mail existe déjà ',
	'Year of birth': 'Année de naissance',
	Registration: 'Enregistrement',
	'Surname of parents': 'Nom du parent',
	School: 'Ecole',
	'Field is required': 'Champ requis',
	'Select age': 'Sélectionner l âge',
	'No such teacher for this year':
		'Cet entraineur n est pas present cette année',
	'User with such phone number already exists':
		'Un utilisateur avec ce numéro de téléphone existe déjà ',
	'You are successfully registered': 'Vous êtes inscrits avec succès',
	'Max length 20 chars': 'Longueur max 20 caractères',

	'INTERNATIONAL SCHOOL': 'ECOLE INTERNATIONALE',
	'Mental Arithmetic': 'CALCUL MENTAL',
	'For children aged 5-14.': 'Pour enfants de 5 à  14 ans.',
	'Sign up for a trial lesson': 'Inscrivez-vous pour une leçon d essai',
	'Parents name': 'Noms des parents',
	'Childs age': 'Age des enfants',
	Country: 'Pays',
	'Sign up': 'S inscrire',
	'Open offer agreement': 'Contract d offre ouverte',
	'Participate in online Indigo Olympiad':
		'Participer à l olympiade indigo en ligne',
	Participate: 'Participer',
	export: 'Exporter',
	wrong: 'Faux',
	right: 'Vrai',
	match: {
		addition: 'Addition-Soustraction',
		multiply: 'Multiplication',
		divide: 'Division',
		abacus_random: 'Boulier aléatoire',
		anzan: 'Anzan',
		negative: 'Négatifs',
		column: 'Colonne',
	},
	timeIsOver: 'Le temps est terminé',
	timer: 'Minuteur',
	'Back to Lessons': 'Retour aux leçons',
	'Create Lesson': 'Créer une leçon',
	Home: 'Accueil',
	Assign: 'Composer',
	'To cabinet': 'Au cabinet',
	'Create a homework': 'Créer un devoir',
	January: 'Janvier',
	February: 'Février',
	March: 'Mars',
	April: 'Avril',
	May: 'Mai',
	June: 'Juin',
	July: 'Juillet',
	August: 'Aout',
	'Group nickname': 'Surnom du groupe',
	September: 'Septembre',
	October: 'Octobre',
	November: 'Novembre',
	December: 'Decembre',
	Overall: 'Globalement',
	Active: 'Actifs',
	'Contract number': 'Numero de contrat',
	'For parents': 'Pour les parents',
	'Choose lessons': 'Sélectionner une leçon',
	Save: 'Attribuer',
	Close: 'Fermer',
	'Change birthday': 'Changer la date de naissance',
	Sent: 'Envoyé',
	'Include students': 'Inclure les étudiants',
	'Add service': 'Ajouter des services',
	'Create folder': 'Créer un dossier',
	Answer: 'Réponse',
	Price: 'Prix',
	'Date of creating': 'Date de création ',
	Month: 'Mois',
	unpaid: 'Non payé',
	paid: 'Payé',
	'Excluded students': 'Etudiants exclus',
	'Selected groups': 'Groupes sélectionnés',
	Monday: 'Lundi',
	Tuesday: 'Mardi',
	Wensday: 'Mercredi',
	Thusday: 'Jeudi',
	Friday: 'Vendredi',
	Saturday: 'Samedi',
	Sunday: 'Dimanche',
	Mo: 'Lun',
	Tu: 'Mar',
	We: 'Mer',
	Th: 'Jeu',
	Fr: 'Ven',
	Sa: 'Sam',
	Su: 'Dim',
	End: 'Fin',
	'Add discount': 'Ajouter une remise',
	Edit: 'Editer',
	'Parent found': 'Parent retrouvé',
	'Changes saved': 'changements sauve-gardés',
	'The passwords of the parent and the student should not coincide':
		"Mot de passe du parent et de l' étudiant ne doivent pas coincider",
	'Your region`s price is set to': 'Le prix de votre region est fixé à',
	'and the holder`s reward is': 'et la plus ancienne récompense est ',
	'regardless of the set price': 'Quelque soit le prix fixé',
	'The given password is not unique for this email':
		'Ce mot de passe donné n est unique pour cet e-mail',
	'Enter a valid email address.': 'Entrer une adresse mail valide .',
	'The phone number entered is not valid':
		'Le numéro de téléphone entré n est pas valide',
	Holiday: '	Vancances',
	'Working days': 'Jours ouvrables',
	Street: 'Rue',
	'Location name': 'Nom de la location',
	District: 'Quartier',
	'Field required': 'Champ obligatoire',
	'Type of legal activity': 'Type d activité légale',
	'Legal address': 'Adresse légale',
	'Registration number': 'Numéro d enregistrement',
	'Add Group': 'Ajouter un groupe',
	'Add Student': 'Ajouter un étudiant',
	Signin: 'S indentifier ',
	'Bonus days': 'Jours bonus',
	'Bonus weeks': 'Semaines bonus',
	'Are you sure you want to delete?':
		'Etes-vous sûr que vous voulez supprimer?',
	Delete: 'Supprimer',
	Days: 'Jours',
	Confirm: 'Confimer',
	Cancel: 'Annuler',
	Week: 'Semaine',
	Weeks: 'Semaines',
	'Group age name': 'Le nom du groupe d âge',
	'Set bonus days': 'Définir des jours bonus',
	'Default language': 'Langage par défaut',
	'With english': 'Avec anglais',
	'Without english': 'Sans anglais',
	'Paid status': 'Status payé',
	'Not paid': 'Non payé',
	Turnover: 'Chiffres d affaire ',
	Block: 'Bloquer ',
	Blocked: 'Bloqués',
	'On holidays': 'En vacances',
	Language: 'Langues',
	Discounts: 'Remises',
	Message: 'Message',
	Subject: 'Sujet',
	Homework: 'Devoir',
	'Homework ': 'Entraînement',
	'Homework on': 'Devoir sur',
	'Sum Sub': 'Addition-Soustraction',
	'You need to complete the exercises': 'Tu dois completer les exercices',
	Homeworks: 'Devoirs',
	'Invoice for': 'Facture de',
	Account: 'Compte',
	'PJSC CB "PRIVATBANK" in Kyiv': 'PJSC CB "PRIVATBANK" à Kiev',
	Supplier: 'Fournisseur',
	Buyer: 'Acheteur',
	'Bank code': 'Code  de banque ',
	'Type phone number or email': 'Taper numéro de téléphone ou email',
	'Type password': 'Taper le mot de passe ',
	'Forgot password': 'Mot de passe oublié',
	'Type your email': 'Taper votre email',
	Send: 'Envoyer',
	'Email sent': 'Email envoyé',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Si vous êtes inscrit au projet, vous recevrez un email avec les prochaines instructions pour récupérer l accès à votre compte',
	'Back to the sign in': 'Retour à la connexion',
	'Password or login is not correct':
		'Le mot de passe ou l identifiant n est pas correct',
	'Password recovery': 'Recuperation du mot de passe',
	'Type your new password here': 'Taper votre nouveau mot de passe ici',
	'Set new password': 'Définir un nouveau mot de passe',
	'Learn more': 'En apprendre davantage',
	'About Us': 'A propos de nous',
	Company: 'Compagnie',
	Jobs: 'Travail',
	Press: 'Presse',
	'Terms of Use': "Conditions d'utilisation",
	'Privacy Policy': 'Politique de confidentialité',
	'Need help?': 'Besoin d aide?',
	'Contact us': 'Contacter nous',
	'Become franchise': 'Devenir franchisé',
	'Select language': 'Séléctionner la langue',
	English: 'Anglais',
	Russian: 'Russe',
	Azerbaijani: 'Azerbaidjanais',
	Ukrainian: 'Ukrainien',
	Polish: 'Polonais',
	French: 'Français',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		"Le calcul mental est une technique de comptage oral qui développe rapidement la capacité intellectuelle et l intelligence d un enfant de 5 à 14 ans  . Le processus de formation se deroule sur un boulier spécial d origine japonaise (Soroban). Le calcul mental entraîne simultanément les hémisphères gauche etdroit du cerveau,améliorant la mémoire visuelle, la concentration de l'attention , l' orientation créative , la pensée imaginative des enfants et leur tendance à la lecture rapide.",
	Management: 'Gestion',
	'Master Franchise': 'Master-franchise',
	Franchise: 'Franchise',
	Teachers: 'Enseignants',
	Groups: 'Groupes',
	Students: 'Etudiants',
	Student: 'Etudiant',
	Parents: 'Parents',
	Profile: 'Profil ',
	'My profile': 'Mon profil',
	Finance: 'Finance',
	Reports: 'Rapports',
	Report: 'Rapport',
	Upload: 'Télécharger',
	List: 'Liste',
	Payments: 'Paiements',
	Documents: 'Documents',
	Lessons: 'Leçons',
	Materials: 'Materiaux',
	Shop: 'Magasin',
	Statistics: 'Statistiques',
	Settings: 'Réglages',
	Pages: 'Pages',
	Logout: 'Se déconnecter',
	Dashboard: 'Tableau de bord',
	'Access denied': 'Accès refusé',
	Create: 'Créer',
	Download: 'Télécharger',
	Status: 'Status',
	'Payment Date': 'Date de paiment',
	'Payment Amount': 'Montant du paiement',
	'Start time': 'Heure de début de classe',
	'Group age': 'Age du groupe',
	Junior: 'Junior',
	Average: 'Moyen',
	Class: 'Classe',
	Older: 'Agés',
	Region: 'Region',
	Group: 'Groupe',
	Person: 'Personne',
	Finances: 'Finances',
	Actions: 'Actions',
	'Choose date': 'Sélectionner date',
	'Send invoice': 'Envoyer une facture',
	'Download invoice': 'Télécharger la facture',
	'Send email': 'Envoyer un mail',
	'Create Student': 'Créer un étudiant',
	'The beginning of holidays': 'Le début des vacances',
	'Start of study': 'Commencement de l apprentissage',
	'Group name': 'Surnom du groupe',
	'Group address': 'Adresse du groupe',
	'Group teacher': 'Enseignant du groupe',
	'Group students': 'Etudiants du groupe',
	'Group statistics': 'Statistiques du groupe',
	Tasks: 'Tâches',
	'Only task': 'Tâche',

	'Current task': 'Tâche courante',
	'Next tasks': 'Prochaine tâche',
	Search: 'Recherche',
	'General information': 'Informations générales',
	'Phone number': 'Numéro de téléphone',
	'First name': 'Prénom',
	Surname: 'Nom de famille',
	'Last name': 'Nom',
	'Date of birth': 'Date de naissance',
	Password: 'Mot de passe',
	'Additional information': 'Informations additionnelles',
	'Id code': 'Id code',
	Passport: 'Passeport',
	'With email newsletter': 'Avec bulletin électronique ',
	'Without email newsletter': 'Sans bulletin électronique',
	'Financial information': 'Informations financières ',
	Royalty: 'Royalties',
	'PR contribution': 'PR contribution',
	Currency: 'Devise',
	Comment: 'Commentaire',
	Paid: 'Payé',
	Invoices: 'Factures',
	Payer: 'Payeur',
	'Payment order': 'Ordre de paiement',
	Code: 'Code',
	'Bank of the recipient': 'Banque du bénéficiare',
	Acts: 'Actes',
	Scan: 'Scanner',
	'Period report': 'Rapport périodique',
	City: 'Ville',
	'Full name franchise': 'Nom complet de la franchise',
	'Students active': 'Etudiants actifs',
	'Сost of education': "Le prix de l' abonnement",
	'Turnover franchise': "Franchise de chiffre d' affaires",
	'Discount sum': 'Somme de remise',
	Proprietor: 'Propriétaire',
	'Additional products and services': 'Produits et services supplémentaires',
	'Full name student': "Nom complet de l' étudiant",
	'Period of study': "Période d' apprentissage",
	'Bonus-days': 'Jours bonus',
	'The beginning of the holidays': 'Commencement des vacances',
	'Amount of days': 'Nombre des jours',
	'Total days': 'Total des jours',
	'Language of instruction': "Langue d' apprentissage",
	Teacher: 'Enseignant',
	Discount: 'Remise',
	Remuneration: 'Rémuneration',
	Goods: 'Articles',
	'Date of creation': 'Date de création',
	'Date of payment': 'Date de paiement',
	'Goods (works, services)': 'Articles (Travaux, Services)',
	Quantity: 'Quantités',
	Units: 'Montant',
	Amount: 'Somme',
	Sum: 'Somme',
	Financial: 'Financier',
	Additional: 'Additionnel',
	General: 'Général',
	Total: 'Total',
	Save: 'Sauve-garder',
	'Including with': 'Y compris avec',
	'Training materials': "Materiaux d' entraînement",
	'Learning contract': "Contact d' apprentissage",
	Games: 'Jeux',
	'NUMBER OF 11 TO 120': 'NOMBRE DE  11 A 120',
	Complexity: 'Complexité',
	Start: 'Commencer',
	'Speedy numbers': 'Addition-Soustraction',
	Anzan: 'Anzan',
	'Abacus is random': 'Boulier aléatoire',
	Multiplication: 'Multiplication',
	Division: 'Division',
	Abacus: 'Boulier',
	'Multiplying by 20': 'Multiplier par 20',
	Squared: 'Elever à la puissance carrée',
	'Division to 20': 'Division par  20',
	Speed: 'Vitesse',
	Repeat: 'Répéter',
	'Game type': 'Type de jeux',
	'Digit type': 'Type de chiffre',
	Digit: 'Chiffre',
	Time: 'Temps',
	Second: 'Second',
	Level: 'Niveau',
	'Action with numbers': 'Action avec les nombres',
	'Action with number': 'Action avec le nombre',
	'Number of expressions': "Nombre d' expressions",
	'Number of expression': "Nombre d' expressions",
	'Imaginary abacus': 'Boulier imaginaire',
	'Calculation method': 'Methode de calcul',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		"Uniquement les nombres négatifs commençant par 99,999,9999 etc., en fonction de la complexité de l'expression: -9, -2, -3, -1...",
	'Only subtraction': 'Soustraction seulement',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Uniquement les nombres positifs commençant par  0. Expression: +1, +4, +6, +9, +5 ...',
	'Only add': 'Addition seulement',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Nombres aléatoirement , en commençant par 0. Expression:: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Nombres aléatoires',
	'CHOOSE COMPLEXITY:': 'CHOISIR UNE COMPLEXITE:',
	'AMOUNT OF ACTIONS WITH NUMBER': "NOMBRE D'ACTIONS ",
	FAMILY: 'FAMILLE',
	'BIG FRIENDS': 'GRANDS AMIS',
	'LITTLE FRIENDS': 'PETITS AMIS',
	'JUST FRIENDS': 'JUSTE AMIS',
	family: 'famille',
	'big friends': 'grands amis',
	'small friends': 'petits amis',
	elementary: 'juste amis',
	Sound: 'Son',
	Loading: 'Chargement en cours',
	back: 'retour',
	Back: 'Retour',
	Add: 'Additionner',
	'Add file': 'Ajouter un fichier',
	ANSWER: 'REPONSE',
	'Congratulations! You did it! Now you can go to the following exercises':
		"BRAVO! tu l'as reussi! A present tu peux passer aux tâches suivantes",
	'RIGHT. ANSWER:': 'REPONSE. CORRECTE:',
	CORRECT: 'CORRECT',
	'NOT CORRECT': 'PAS CORRECT',
	'Try again': 'Essayer à nouveau',
	expression: 'expression ',
	Lesson: 'Leçon',
	Oral: 'Nombre oral',
	'History statistics': 'Historique des statistiques',
	Open: 'OUVRIR',
	'Game statistics per day': 'Statistiques du jeu du jour',
	'Total played games': 'Total des jeux joués',
	'Total correct answers': 'Total des réponses correctes',
	'Total played:': 'Total joués',
	Feedback: 'Feedback',
	'Leave a review': 'Laisser un commentaire',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Laissez-nous vos commentaires ou souhaits et nous les prendrons certainement en comptes dans notre travail.',
	next: 'Suivant',
	Next: 'Suivante',
	Previous: 'Précedent',
	'Payment history': 'Historique de paiements',
	'Payment status': 'Statut de paiements',
	Pay: 'Payer',
	'Getting a discount': 'Obtenir une remise',
	Training: 'Entraînement',
	'Online abacus': 'Boulier en ligne',
	'Base 50/100': 'Base 50/100',
	multiply_base: 'Base 50/100',
	divided: 'Divisé',
	'Do not show this instruction again':
		'Ne pas montrer à nouveau cette instruction',
	'Instructions for homework': 'Instructions pour devoirs',
	divider: 'Diviseur',
	'Multiplication table': 'Table de multiplication',
	Restore: 'Restaurer',
	Left: 'Restes',
	New: 'Nouveau',
	'Restore Hierarchy': 'Restaurer la hiérarchie',
	total: 'total',
	active: 'actifs',
	blocked: 'bloqués',
	pageError: {
		'403': "L'accès est refusé.",
		'404': "Cette page n'existe pas.Réessayer",
		'500': 'Le serveur ne répond pas. Réessayer.',
	},
	error: {
		'Account deactivated': 'Votre compte a été désactivé',
	},
	modalNewVersion: {
		text:
			'Vous utilisez une version ancienne du site./n la mise à jour est maintenant disponible.',
		btn: 'Mettre à jour',
	},
	games: {
		negativeNumbers: 'Nombres négatifs',
		pause: 'Pause',
		resume: 'Continuer',

		columns: {
			name: 'Colonnes',
			users: 'nombre de joueurs',
			user: 'Joueur',
			userNames: 'Noms de joueurs',
		},
	},
	'Indigo-dollars': 'Dollars Indigo',
	Balance: 'Solde',

	modalIndigoDollars: {
		submit: 'Envoyer',
		cancel: 'Annuler',
		title: 'Dollars Indigo',
		balance: 'Solde actuel',
		amount: 'Montant',
		reason: 'Commentaires',
	},

	modalAddNotification: {
		title: 'Ajouter un message',
		submit: 'Envoyer',
		cancel: 'Annuler',
		empty: 'Pas de message',
	},

	modalTransactionsHistory: {
		title: 'Historique de paiement',
		type: {
			withdraw: 'Retirer',
			deposit: 'Dépôt',
		},
		empty: 'La liste de paiement est vide',
	},

	modalCopyHomework: {
		title: 'Copier les devoirs',
		label: 'Choisir la date à laquelle copier les devoirs',
		submit: 'Copier',
		cancel: 'Annuler',
	},

	reportsPage: {
		history: {
			title: 'Historique des modifications',
			empty: 'La liste est vide',
			table: {
				date: 'dqte de modification',
				field_name: 'Action',
				old_value: 'ancienne valeur',
				new_value: 'nouvelle valeur',
				user: "Modifié par l' utilisateur",
			},
		},
	},

	pageShop: {
		title: 'Magasin',
		description:
			"Dans le magasin , vous pouvez acheter divers produits pour améliorer l'apparence visuelle de votre éspace personnel.",

		tabs: {
			all: 'Tous les articles',
			purchased: 'Acheté',
		},

		item: {
			off_all: 'Non',

			status: {
				AVAILABLE: 'Disponible',
				DEPRECATED: 'Pas disponible',
				COMING_SOON: 'Bientôt disponible',
			},
			is_activated: 'Choisi',
			set_active: 'Choisir',
			unset_active: 'fermer',
			preview: 'Regarder',
			is_free: 'Gratuit',
			buy: 'Acheter',
			bought: 'Acheté',
			purchased: 'Achetés',
		},
		empty: {
			all: "Il n'y a pas d'articles disponibles",
			purchased: "Il n' y a pas d' articles achetés",
		},

		toast: {
			error: "Une erreur s'est produite",
			notEnoughMoney: "Pas assez d' argent",
			itemBought: 'Article acheté',
			itemActivated: "l'article est activé",
			itemDeactivated: "L' article est désactivé",
		},
		confirmPurchase: {
			title: "Confirmer l'achat",
			message: 'Êtes-vous sûr de vouloir acheter cet article?',
			confirm: 'Oui, acheter',
			cancel: 'Annuler',
		},
	},

	demo: {
		title: 'Leçon de démonstration gratuite',
		tutorial: {
			title: 'Instructions',
			text:
				"Félicitations, vous avez rejoint le monde en ligne du calcul mental d' Indigo Mental.\nIndigo Mental - c'est la meilleure école de calcul mental au monde, les nombreuses années d' expérience de l' entreprise et le succès de nombreux étudiants à travers le monde aux Olympiades prouvent que cette méthode est efficace et unique. De nombreux parents sont depuis longtemps convaincus de l' efficacité de la méthode et se réjouissent du succès de leurs enfants non seulement en calcul mental, mais dans d'autres sciences, musique,sportset notent un grand bond dans les capacités intellectuelles de leurs enfants.\nМентальна арифметика - c'est une méthode japonaise de comptage oral rapide,qui développe rapidement les capacités mentales et l'intelligence de l' enfant. Le processus d' apprentissage se déroule sur des bouliers spéciaux japonais(Soroban). Le calcul mental entraîne simultanément les hémisphères gauche et droit du cerveaau, améliorant la mémoire visuelle,l'attention, la concentration créative et la pensée imaginative des enfants.\nCommençons à apprendre le calcul mental,pour cela cliquez sur le bouton 'PLAY' sur la vidéo ci-dessous, écoutez zt répétez.",
		},
	},

	disableStudent: {
		btn: 'Déconnecter un étudiant',
		list: 'Etudiants sans date de désactivation',
		modal: {
			title: "Déconnexion de l' étudiant",
			description: 'Vous êtes sur le point de déconnecter un étudiant',
			fieldLabel: 'Sélectionner les mois',
			btnSubmit: 'Fermer',
			btnCancel: 'Annuler',
		},
	},
}
